import styled, { css } from 'styled-components'
import * as styledSystem from 'styled-system'
import { colors } from './helpers'
const { space, width, fontSize, lineHeight, maxWidth, textAlign, letterSpacing, display, color, fontWeight } = styledSystem

const capitalizeFirstLetter = css`
  ::first-letter {
    text-transform: capitalize;
  }
`

export const baseTextStyle = css`
  font-family: 'Oxanium', sans-serif !important;
  margin-top: 0px;
  color: rgb(54, 49, 61);
  ${space};
  ${display};
  ${width};
  ${maxWidth};
  ${textAlign};
  ${(props) => props.capitalize && capitalizeFirstLetter};
  ${fontSize};
  ${fontWeight};
  ${lineHeight};
  ${letterSpacing};
  ${color}
`

export const H1 = styled.h1`
  ${baseTextStyle};
  font-size: 40px;
  font-weight: 600;
  line-height: 40px;
`

export const H2 = styled.h2`
  ${baseTextStyle};
  font-size: 24px;
  line-height: 30px;
`

export const H3 = styled.h3`
  ${baseTextStyle};
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
`

export const H4 = styled.h4`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  ${baseTextStyle};
`

export const SeoH2 = styled.h3`
  ${baseTextStyle};
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
`

export const SeoH3 = styled.h3`
  ${baseTextStyle};
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
`

export const SeoH4 = styled.h3`
  ${baseTextStyle};
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
`

const largeTextStyles = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: 300;
`

const smallTextStyles = css`
  font-size: 14px;
  line-height: 20px;
  font-weight: 300;
`

const boldTextStyles = css`
  font-weight: 600;
`

const linkTextStyles = css`
  text-decoration-line: underline;
  cursor: pointer;
  font-weight: 500;
`

export const Text = styled.p`
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  ${(props) => props.link && linkTextStyles};
  ${(props) => props.bold && boldTextStyles};
  ${baseTextStyle};
`

export const LargeDigits = styled.span`
  ${baseTextStyle};
  font-size: 40px;
  line-height: 24px;
  letter-spacing: 9.9px;
  font-weight: 700;
`

export const Label = styled.p`
  ${baseTextStyle};
  font-size: 16px;
  line-height: 21px;
  font-weight: 500;
  ${(props) => props.small && smallTextStyles}
`

export const Error = styled.p`
  ${baseTextStyle};
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  ${(props) => props.small && smallTextStyles}
`

export const Span = styled.span`
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  ${baseTextStyle};
  ${(props) => props.bold && boldTextStyles}
  ${(props) => props.link && linkTextStyles}
`
export const LinkSpan = styled.span`
  color: ${colors.fontLinks};
  cursor: pointer;
`

export const Li = styled.li`
  &::before {
    content: '•';
    font-size: 18px;
    font-weight: bold;
    margin-left: -1em;
    width: 1em;
    display: inline-block;
  }
  p {
    display: inline-block;
  }
`
